// Vendor Libs
import React from 'react';

// Components
import FlexDashboard from '../core/flex-dashboard';
import DisplayPathModifiers from '../search-data/display-path-modifiers';
import EditDisplayPathModifier from '../app/edit-display-path-modifier';
import CreateDisplayPathModifier from '../app/create-display-path-modifier';

// Configs
import getDashboardConfig from '../../../config/flex-dashboard-config';

// Styles
import './dashboard-display-path-modifiers.scss';

const dashboardConfig = {
    layout: {
        type: 'row',
        children: [
            {
                type: 'row',
                children: [
                    {
                        type: 'tabset',
                        children: [
                            {
                                type: 'tab',
                                name: 'Display Path Modifiers',
                                component: DisplayPathModifiers,
                            },
                        ],
                    },
                ],
            },
            {
                type: 'tabset',
                children: [
                    {
                        type: 'tab',
                        name: 'Create Display Path Modifier',
                        component: CreateDisplayPathModifier,
                        config: {
                            componentProps: {},
                        },
                    },
                    {
                        type: 'tab',
                        name: 'Edit Display Path Modifier',
                        component: EditDisplayPathModifier,
                        config: {
                            componentProps: {},
                        },
                    },
                ],
            },
        ],
    },
};

function DashboardDisplayPathModifiers() {
    return <FlexDashboard dashboardConfig={getDashboardConfig(dashboardConfig)} dashboardName="displayPathModifiers" />;
}

export default DashboardDisplayPathModifiers;
